var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsTool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.363,
    height: 96.37,
    viewBox: "0 0 96.363 96.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_96e0ff5ff4971065bb26581423e89a01",
    "data-name": "96e0ff5ff4971065bb26581423e89a01",
    transform: "translate(-0.708 -0.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M34.858,49.382a1.058,1.058,0,0,1-.791-.283l-6.555-6.612a21.252,21.252,0,0,1-25.939-26.5,1.117,1.117,0,0,1,1.865-.452l9.777,9.72L25.251,13.214l-9.72-9.777a1.117,1.117,0,0,1,.452-1.865,21.252,21.252,0,0,1,26.5,25.939L49.1,34.067a1.157,1.157,0,0,1-1.074,1.921L35.989,48.026A1.132,1.132,0,0,1,34.858,49.382Zm40.972,47.7A21.3,21.3,0,0,1,55.259,70.292l-5.821-5.877c-1.074-1.017.565-2.656,1.639-1.582l.057.057L62.719,50.908a1.125,1.125,0,0,1,1.7-1.469l5.877,5.821a21.252,21.252,0,0,1,25.939,26.5,1.151,1.151,0,0,1-1.921.509L84.589,72.5,72.5,84.533l9.777,9.777a1.156,1.156,0,0,1-.509,1.921A21.51,21.51,0,0,1,75.83,97.079Z",
    transform: "translate(0 0)",
    fill: "#eee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M30.586,1291.854a1.174,1.174,0,0,1-1.13-1.469l6.216-21.588a1.161,1.161,0,0,1,1.921-.452l15.371,15.371a1.124,1.124,0,0,1-.509,1.865Z",
    transform: "translate(-27.092 -1195.679)",
    fill: "#ffeac3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M30.586,1454.128a1.174,1.174,0,0,1-1.13-1.469L33.129,1440l10.4,10.455Z",
    transform: "translate(-27.092 -1357.954)",
    fill: "#494f54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M153.332,302.237,137,285.9l.226-.735a.911.911,0,0,1,.226-.4h0l58.886-58.886a1.141,1.141,0,0,1,1.7,1.526L211.766,241.2a1.141,1.141,0,0,1,1.582,1.639l-58.886,58.886a.781.781,0,0,1-.509.283v.057Z",
    transform: "translate(-128.59 -212.109)",
    fill: "#3666f6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M217.194,376.928,209,368.734,268.734,309l8.194,8.138Z",
    transform: "translate(-196.521 -290.869)",
    fill: "#494f54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1197.5,96.92a1.116,1.116,0,0,1-.791-.339l-15.371-15.371a1.092,1.092,0,0,1,0-1.582l7.007-7.008a7.3,7.3,0,0,1,10.285,0l6.725,6.668a7.3,7.3,0,0,1,0,10.285l-7.008,7.008A1.15,1.15,0,0,1,1197.5,96.92Z",
    transform: "translate(-1113.59 -65.848)",
    fill: "#247a3d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M1120,234.843l3.786-3.786.057-.057,1.639,1.582h0l2.769,2.826,8.194,8.138,2.769,2.826h0l1.639,1.582-.056.057-3.786,3.786-4.408-4.351-8.194-8.194Z",
    transform: "translate(-1056.038 -217.277)",
    fill: "#dde2e8",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsTool);
export default __webpack_public_path__ + "static/media/settings-tool.3a9277630eda78633a28924f4021f2f2.svg";
export { ForwardRef as ReactComponent };